import React, { useEffect, useState } from "react";
import BreadCrumbs from "../common/BreadCrumbs";
import Search from "../components/blogs/Search";
import Category from "../components/blogs/Category";
import RecentBlogs from "../components/blogs/RecentBlogs";
import Tag from "../components/blogs/Tag";
import BlogGrid from "../components/blogs/BlogGrid";
import { BLOGS } from "../constants/BlogConstant";
import {
  filterBlogs,
  filterBlogsByCategory,
  filterBlogsByTag,
} from "../utils/blogUtils";
import { useSearchParams } from "react-router-dom";

const Blogs = ({
  setTab,
}: {
  setTab: React.Dispatch<React.SetStateAction<string>>;
}) => {
  useEffect(() => {
    setTab("projects");
  }, [setTab]);

  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = parseInt(searchParams.get("page") || "1");
  const searchParam = searchParams.get("query") || "";

  const [searchQuery, setSearchQuery] = useState(searchParam);
  const [filteredBlogs, setFilteredBlogs] = useState(BLOGS);
  const [currentPage, setCurrentPage] = useState(pageParam);
  const [blogCount, setBlogcount] = useState(BLOGS.length);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedTag, setSelectedTag] = useState<string | null>(null);

  const handleFilterByTag = (tag: string) => {
    const result = filterBlogsByTag(BLOGS, tag);
    setFilteredBlogs(result);
    setBlogcount(result.length);
    setSelectedTag(tag);
    setSelectedCategory(null);
    setCurrentPage(1);
  };

  const handleFilterByCategory = (name: string) => {
    const result = filterBlogsByCategory(BLOGS, name);
    setFilteredBlogs(result);
    setBlogcount(result.length);
    setSelectedCategory(name);
    setSelectedTag(null);
    setCurrentPage(1);
  };

  const blogsPerPage = 6;
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  useEffect(() => {
    const params: Record<string, string> = { page: currentPage.toString() };
    if (searchQuery) {
      params.search_query = searchQuery;
    }
    setSearchParams(params);
  }, [currentPage, searchQuery, setSearchParams]);

  useEffect(() => {
    const results = filterBlogs(searchQuery);
    setFilteredBlogs(results);
    setBlogcount(results.length);
    setCurrentPage(1);
  }, [searchQuery]);

  const startIndex = (currentPage - 1) * blogsPerPage;
  const endIndex = startIndex + blogsPerPage;
  const currentBlogs = filteredBlogs.slice(startIndex, endIndex);

  const handlePageChange = (pageNumber: number) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleSearch = (search_query: string) => {
    setSearchQuery(search_query);
  };

  return (
    <>
      <BreadCrumbs title="Blog" description="Exploring The AppThing Blog" />

      <div className="home3-blog-area sec-mar">
        <div className="container">
          <div className="row g-lg-4 gy-5">
            <div className="col-lg-8">
              <BlogGrid blogs={currentBlogs} gridClass="" />
              {blogCount > blogsPerPage && (
                <div className="row">
                  <nav aria-label="Page navigation example">
                    <ul className="pagination justify-content-center">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}>
                          <i className="bi bi-arrow-left"></i>
                        </button>
                      </li>
                      {Array.from({ length: totalPages }, (_, index) => (
                        <li
                          key={index + 1}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}>
                          <button
                            className="page-link"
                            onClick={() => handlePageChange(index + 1)}>
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}>
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}>
                          <i className="bi bi-arrow-right"></i>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>
            <div className="col-lg-4">
              <div className="widget-area">
                <Search onSearch={handleSearch} />
                <Category selectedCategory={selectedCategory} handleFilterByCategory={handleFilterByCategory} />
                <RecentBlogs />
                <Tag selectedTag={selectedTag} handleFilterByTag={handleFilterByTag} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogs;
